// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SlimSelect from './slim_select_controller'
application.register('slim-select', SlimSelect)

import ScrollProgress from '@stimulus-components/scroll-progress'
application.register('scroll-progress', ScrollProgress)
